import { DataSyncBase } from '@/class/model/DataSyncBase'

export class DataSyncRefNoBase extends DataSyncBase {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get externalRefNo() {
    return this._data.externalRefNo
  }
  set externalRefNo(externalRefNo) {
    this._data.externalRefNo = externalRefNo
  }
}
